import { FC, useContext } from 'react';
import { CbArrow } from '../Buttons/CbArrow';
import { TableContext } from './';
import { inflect, titleize } from 'inflection';
import styles from './TablePagination.module.css';
export const TablePagination: FC = () => {
  const context = useContext(TableContext);
  const {
    loading,
    paginationInfo: {
      hasNextPage,
      hasPrevPage,
      label,
      nextPage,
      page,
      perPage,
      prevPage,
      totalResults
    },
    rows
  } = context;
  const firstResult = (page - 1) * perPage + 1;
  const lastResult = firstResult + rows.length - 1;
  const inflectionCount = totalResults == 'Many' ? 2 : totalResults;
  const description = titleize(inflect(label, inflectionCount as number));
  const text = totalResults ? `${firstResult}-${lastResult} of ${totalResults} ${description}` : `No ${description}`;
  const info = <div>
      <span>{loading ? null : text}</span>
    </div>;
  const controls = <div className={styles.paginationControls}>
      <CbArrow aria-label="previous-page" direction="left" isDisabled={!hasPrevPage} onClick={prevPage} />
      <CbArrow aria-label="next page" isDisabled={!hasNextPage} onClick={nextPage} />
    </div>;
  return <div className={styles.container} data-sentry-component="TablePagination" data-sentry-source-file="TablePagination.tsx">
      {info}
      {controls}
    </div>;
};